import * as Yup from 'yup'

export const CampaignContactSchema = Yup.object().shape({
  name: Yup.string().required('This field is required.'),
  phone: Yup.string().required('This field is required.'),
  email: Yup.string()
  .required('Required')
  .email('Invalid email'),
});